<template>
  <div id="gallery">
    <span class="gallery--top">
      <Chars
        :translations="translations"
        :config="config"
        :dataResult.sync="dataResult"
        :showElements="showElements"
        @update-gallery="updateGallery"
        class="mb-element"
      />
      <Category
        :translations="translations"
        :config="config"
        :dataResult.sync="dataResult"
        :showElements="showElements"
        @update-gallery="updateGallery"
        class="mb-element"
      />
      <Search
        :translations="translations"
        :config="config"
        :dataResult.sync="dataResult"
        :showElements="showElements"
        @update-gallery="updateGallery"
        class="mb-element"
      />
    </span>

    <div class="gallery--list col-xs-12">
      <div class="row">
        <GalleryList
          v-for="(gallery, i) in galleryList"
          :gallery="gallery"
          :firstCharOld="i > 0 ? galleryList[i - 1].firstChar : ''"
          :key="i"
        />
        <span
          class="empty-list col-xs-12"
          v-if="galleryList.length === 0"
          v-html="emptyList"
        ></span>
      </div>
    </div>
    <div v-if="this.loading">{{ this.translations.applicationLoading }}</div>
    <div class="box col-xs-12 d-block" v-in-viewport ref="siteEnd"></div>
  </div>
</template>

<script lang="js">
import Chars from "./elements/Chars";
import Category from "./elements/Category";
import Search from "./elements/Search";
import GalleryList from "./elements/GalleryList";
import axios from "axios";

export default {
  name: 'Gallery',
  components: {
    Chars,
    Category,
    Search,
    GalleryList
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      galleryList: {},
      footerHeight: 0,
      dataResult: {
        "categories": [],
        "firstChar": "",
        "searchPhrase": ""
      },
      showElements: 9,
      totalElements: 0,
      activeElements: 9,
      page: 1,
      totalPages: 0,
      observer: null,
      first: true,
      emptyList: this.translations.noResults,
      loading: false
    };
  },
  methods: {
    refreshGalleryList() {
      this.loading = true;
      const json = JSON.stringify(this.dataResult);
      const url = this.config.filter + '?language=' + this.config.language + '&size=' + this.showElements + '&page=' + this.page;
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };

      axios.post(url, json, config)
          .then(response => {
            for (let i = 0; i < response.data.gallerieSearchList.length; i++) {
              this.galleryList.push(response.data.gallerieSearchList[i]);
            }
            this.activeElements = this.galleryList.length;
            this.totalPages = response.data.totalPages;
            this.loading = false;
          })
          .catch(e => {
            console.log(e);
          });
    },
    getGalleryList() {
      const json = JSON.stringify(this.dataResult);
      const url = this.config.filter + '?language=' + this.config.language + '&size=' + this.showElements + '&page=' + this.page;
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      axios.post(url, json, config)
          .then(response => {
            this.galleryList = response.data.gallerieSearchList;
            this.totalElements = response.data.totalElements;
            this.showElements = response.data.resultsOnPage;
            this.totalPages = response.data.totalPages;
            this.page = 1;
            // console.log("getG:" + this.totalPages);
          })
          .catch(function (error) {
            // console.log(error);
            document.getElementById("gallery").innerHTML = error;
          });
    },
    updateGallery(list, totalPages) {
      this.galleryList = list;
      // console.log(this.galleryList);
      this.page = 1;
      this.totalPages = totalPages;
    },
    onClassChange(classAttrValue) {
      const classList = classAttrValue.split(' ');
      if (classList.includes('in-viewport')) {
        if (this.first) {
          this.getGalleryList();
          this.first = false;
        } else {
          this.page = this.page + 1;
          if (this.page <= this.totalPages) {
            this.refreshGalleryList();
          }
        }
      }
    }
  },
  mounted() {
    this.observer = new MutationObserver(m => {
      if (!this.loading) {
        const newValue = m[0].target.getAttribute(m[0].attributeName);
        this.$nextTick(() => {
          this.onClassChange(newValue);
        });
      }
    });
    this.observer.observe(this.$refs.siteEnd, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class'],
    });
  },
  beforeDestroy() {
    this.observer.disconnect();
  }
};
</script>
